// @flow
import React from 'react';
import {connect} from 'react-redux'
import AbstractField from './AbstractField';
import ApiObjectSuggestField from './../field/ApiObjectSuggestField';
import {Button, Modal} from 'reactstrap';
import Icon from './../icon/FAIcon';
import * as ModalActions from './../modal/ModalActions';
import AdresaForm from './../form/AdresaForm';
import {reduxForm} from 'redux-form'
import {mergeAddons} from "./../utils"
import {COMPONENT_CHILDREN} from './../Utils2';
import {i18n} from './..';
import AdresaApi from "./../api/gen/adresy/AdresaApi";
import highlightText from "./../utils/highlightText";
import * as TypAdresy from "../api/gen/proxioapi/TypAdresy";

/**
 * Adresa Field
 *
 * Použití pro dohledání / ztotožnění adres
 *
 * Lze vyvolat dialog s editací
 *
 * TODO @compel/@stanekpa možná udělat verzi bez connectu
 */
class AdresaField extends AbstractField {

    static PropTypes = {
        typyAdres: React.PropTypes.array,
        obecIds: React.PropTypes.array,
        apiRequestDelay: React.PropTypes.number,
        offlineMode: React.PropTypes.bool,
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
    };

    static defaultProps = {
        obecIds: [],
        apiRequestDelay: 250,
        typyAdres: [TypAdresy.K],
        // Aktualne je vychozi hodnota offline mode resena velmi jednoduse pres globalni konfiguraci aplikace.
        // Pokud neni parametr v globalni konfiguraci nastaven, predpokladame jeho hodnotu true (tzn. online mode),
        // kvuli zpetne kompatibilite.
        offlineMode: window.appConfig && window.appConfig.xrnConfigured === false,
    }

    handleFilterSuggestions = (value) => {
        const {typyAdres, obecIds} = this.props;

        const params: FindAdresyParams = {
            fulltext: value,
            typyAdres,
            obecIds,
            max: 20,
            ["@class"]: "FindAdresyParamsVO"
        };

        return AdresaApi.findAdresy(params);
    };

    /**
     * Zobrazení náhledu adresy.
     */
    handleShow = () => {
        const {value, disabled} = this.props;
        const useValue = typeof value === "string" ? {} : value;  // při prázdné dává redux form string!
        this.dispatch(ModalActions.show(AdresaForm, {
            preview: disabled,
            initialValues: useValue
        }, i18n("adresa.form.title"), {size: "md"}));
    };

    handleEdit = () => {
        const {value, offlineMode} = this.props;
        const useValue = typeof value === "string" ? {} : value;  // při prázdné dává redux form string!
        this.dispatch(ModalActions.show(AdresaForm, {
            onSubmit: this.handleAdresaFormSubmit,
            overeniDisabled: offlineMode,
            initialValues: {"@class":"AdresaVO", ...useValue},
        }, i18n("adresa.form.title"), {size: "md"}));
    };

    handleClear = () => {
        this.props.onChange(null);
    };

    handleAdresaFormSubmit = (data) => {
        const {onChange} = this.props;
        this.dispatch(ModalActions.hide());
        onChange(data);
    };

    render() {
        const {addonsAfter, typyAdres, dispatch, obecIds, apiRequestDelay, value, offlineMode, ...other} = this.props;
        const {disabled} = this.props;
        const editAddons = [];

        if (!disabled && offlineMode) {
            editAddons.push(
                <div className="input-group-btn" key="clear-btn">
                    <Button disabled={disabled} onClick={this.handleClear}>
                        <Icon icon='times'/>
                    </Button>
                </div>
            );
        }

        editAddons.push(
            <div className="input-group-btn" key="edit-btn">
                {(disabled && value) ? (
                    // je zakázán a má hodnotu, zobrazíme akci pro zobrazení náhledu
                    <Button type="button" onClick={this.handleShow}>
                        <Icon icon='eye'/>
                    </Button>
                ) : (
                    // standardní zobrazení pro editaci, může být zakázané, pokud je zakázán a nemá hodnotu
                    <Button type="button" disabled={disabled} onClick={this.handleEdit}>
                        <Icon icon='edit'/>
                    </Button>
                )}
            </div>
        )

        const finalAddonsAfter = mergeAddons(addonsAfter, editAddons);

        if (offlineMode) {
            const field = <input type="text" className="form-control" readOnly
                                 value={value && value.popis} {...other}/>;
            return this.renderFieldWithAddons(field, null, finalAddonsAfter);
        }

        return (
            <ApiObjectSuggestField
                value={value}
                minCharsForFilter={3}
                placeholder="Vyhledat adresu..."
                filterSuggestions={this.handleFilterSuggestions}
                itemValueAttrName="popis"
                apiRequestDelay={apiRequestDelay}
                addonsAfter={finalAddonsAfter}
                dispatch={dispatch}
                {...other}
            />
        )
    }
}
export default connect()(AdresaField);
// export default AdresaField;
